import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('cyber_heist', {
  cherry: 'keycard',
  lemon: 'data_chip',
  orange: 'drone',
  bell: 'alarm_beacon',
  star: 'hologram_wild',
  seven: 'vault_door',
  gem: 'data_crystal',
  scatter: 'cyber_lock_scatter',
  money: 'credit_vault',
});

/** Cyber Heist — GENERATED by scaffoldSlot from
 *  content/slots/cyber_heist.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const CYBER_HEIST_THEME: Theme = {
  id: 'cyber_heist',
  name: 'Cyber Heist',
  palette: {
    accent: 0x8a40c0,
    secondary: 0xb47ae0,
    warm: 0xf2d27a,
    frameFill: 0x160e24,
    bgGradientTop: 0x2c1848,
    bgGradientBottom: 0x0d0618,
    dimOverlay: 0x06030d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Keycard', glyph: '💳', tint: 0x4080c0, weight: 5, textureAlias: 'cyber_heist:cherry',
        winVideoAlias: 'cyber_heist:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Data Chip', glyph: '💾', tint: 0xc0a040, weight: 5, textureAlias: 'cyber_heist:lemon',
        winVideoAlias: 'cyber_heist:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Drone', glyph: '🛸', tint: 0xc06040, weight: 4, textureAlias: 'cyber_heist:orange',
        winVideoAlias: 'cyber_heist:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Alarm', glyph: '🚨', tint: 0xd03030, weight: 3, textureAlias: 'cyber_heist:bell',
        winVideoAlias: 'cyber_heist:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Cyber Heist', glyph: '👾', tint: 0x8a40c0, weight: 2, textureAlias: 'cyber_heist:star',
        winVideoAlias: 'cyber_heist:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Vault', glyph: '🔐', tint: 0xa0a4ac, weight: 2, textureAlias: 'cyber_heist:seven',
        winVideoAlias: 'cyber_heist:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Data Crystal', glyph: '💎', tint: 0x9040d0, weight: 2.5, textureAlias: 'cyber_heist:gem',
        winVideoAlias: 'cyber_heist:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Cyber Lock', glyph: '🔒', tint: 0xc040a0, weight: 0.5, textureAlias: 'cyber_heist:scatter',
        winVideoAlias: 'cyber_heist:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Credit Vault', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'cyber_heist:money',
        winVideoAlias: 'cyber_heist:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x160e24, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x8a40c0, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x160e24, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xb47ae0, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x8a40c0, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x160e24, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x8a40c0, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'cyber_heist:bg', path: 'environment/cyber_heist.png' },
      columnBackground: { alias: 'cyber_heist:column_bg', path: 'reel/cyber_heist_column_bg.png' },
      border: { alias: 'cyber_heist:border', path: 'brand/border_neon.png' },
    },
  },
};
